import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=dcf9d1fc&scoped=true&"
import script from "./Article.vue?vue&type=script&lang=js&"
export * from "./Article.vue?vue&type=script&lang=js&"
import style0 from "./Article.vue?vue&type=style&index=0&id=dcf9d1fc&prod&scoped=true&lang=css&"
import style1 from "./Article.vue?vue&type=style&index=1&id=dcf9d1fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf9d1fc",
  null
  
)

export default component.exports